import { AppState } from '@redux/store';


export function getAppConfig(state: AppState) {
    return state.config;
}
